<template>
  <ConfirmDialog :name="confirmName">
    <BravadoText variant="body">The post will be permanently removed from the feed and your profile.</BravadoText>
    <template slot="actions">
      <BravadoButtonV3 variant="secondary" @click="$modal.hide(confirmName)">Cancel</BravadoButtonV3>
      <BravadoButtonV3 variant="danger" @click="handleDelete">Remove</BravadoButtonV3>
    </template>
  </ConfirmDialog>
</template>

<script lang="ts">
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import type { IPost, IPostCategory, IPostContentDataDealStory } from '@/types/community';
import { DEFAULT_FEED_PATH, DEFAULT_FEED_ROUTE, confirmNames } from '~/components/partials/war-room/constants';
import BravadoButtonV3 from '~/components/common/BravadoButtonV3/BravadoButtonV3.vue';
import ConfirmDialog from '~/components/common/ConfirmDialog.vue';
import { categoryNames } from '~/components/partials/war-room/WarRoomPostForm/WarRoomPostFormCategories/constants';

export default Vue.extend({
  name: 'WarRoomConfirmRemovePost',
  components: { ConfirmDialog, BravadoButtonV3 },
  data() {
    return {
      confirmName: confirmNames.DELETE_POST,
    };
  },
  computed: {
    ...mapGetters('warRoom', ['postBySlug']),
  },
  methods: {
    ...mapActions('warRoom', ['deletePost']),
    ...mapActions('deals', ['deleteDeal']),
    handleDelete(): void {
      try {
        const post = this.postBySlug(this.$route.query.post_slug);

        if (this.$route.name === DEFAULT_FEED_ROUTE) {
          this.deletePostByCategory(post);
          return;
        }

        this.$router.push({ path: DEFAULT_FEED_PATH }, () => this.deletePostByCategory(post));
      } catch (e) {
        this.$notice.error(e);
        this.$sentryUtils.error(e);
      }
    },
    deletePostByCategory(post: IPost): void {
      const isDealStory = (post.category as IPostCategory).slug === categoryNames.WIN_WIRE;

      isDealStory
        ? this.deleteDeal({ deal: (post.content.data as IPostContentDataDealStory).deal })
        : this.deletePost({ post });

      this.$modal.hide(this.confirmName);
    },
  },
});
</script>
